import { createSelector } from 'reselect';

import type { State, AuthState } from '@wetransfer/transfer/store/types';

export const selectAuthState = (state: State): AuthState => state.auth;

export const selectAuth0UserId = createSelector(
  selectAuthState,
  (auth: AuthState): string | undefined => auth?.auth0UserId
);
